import { useUrlGenerator } from '@folklore/routes';
import classNames from 'classnames';
import camelCase from 'lodash-es/camelCase';
import { ReactNode } from 'react';

// import { FormattedMessage } from 'react-intl';
// import useFontSize from '../../hooks/useFontSize';

import normalizeCardTheme from '../../lib/normalizeCardTheme';

import BrandLogoNormalized from '../icons/BrandLogoNormalized';
import DocumentsList from '../lists/DocumentsList';
import BrandSummary from '../summaries/BrandSummary';

import styles from '../../styles/cards/brand-documents-card.module.css';

interface BrandDocumentsCardProps extends Partial<Brand> {
    theme?: CardTheme | LegacyCardTheme | null;
    size?: CardSize | null;
    ratio?: CardRatio | null;
    listTitle?: ReactNode | null;
    listProps?: Record<string, unknown> | null;
    listCount?: number | null;
    listQuery?: Record<string, unknown> | null;
    placeholder?: boolean;
    withoutText?: boolean;
    className?: string | null;
}
function BrandDocumentsCard({
    id = null,
    slug = null,
    handle = null,
    shortDescription = null,
    theme: providedTheme = null,
    size = null,
    ratio = null,
    listTitle = null,
    listProps = null,
    listCount = 3,
    listQuery = null,
    placeholder = false,
    withoutText = false,
    className = null,
}: BrandDocumentsCardProps) {
    const theme = normalizeCardTheme(providedTheme);
    const url = useUrlGenerator();
    return (
        <div
            className={classNames([
                styles.container,
                {
                    [styles.withoutText]: withoutText,
                },
                styles[camelCase(handle)],
                styles[camelCase(ratio)],
                className,
            ])}
            data-brand={handle}
        >
            <BrandSummary
                slug={slug}
                // label={label}
                description={shortDescription}
                image={
                    handle !== null ? (
                        <BrandLogoNormalized brand={handle} className={styles.logo} />
                    ) : null
                }
                imagePosition="top"
                className={styles.summary}
                imageClassName={styles.summaryImage}
                pictureClassName={styles.summaryPicture}
                titleClassName={styles.summaryTitle}
                descriptionClassName={styles.summaryDescription}
                withoutTitle
                placeholder={placeholder}
                withLink
                link={
                    slug !== null
                        ? url('home', {
                              brand: slug,
                          })
                        : '#'
                }
            />
            {listTitle !== null ? <div className={styles.title}>{listTitle}</div> : null}
            <DocumentsList
                query={
                    !placeholder
                        ? {
                              brand: id,
                              ...listQuery,
                          }
                        : null
                }
                disabled={placeholder}
                cardType="horizontal"
                cardRatio={ratio}
                cardSize={size}
                cardTheme={theme}
                count={listCount}
                columns={1}
                placeholder={placeholder}
                className={styles.list}
                {...listProps}
            />
        </div>
    );
}
export default BrandDocumentsCard;
